import { Checkbox, checkboxStates } from "@visiblethread/react-components";
import clsx from "clsx";
import Flex from "components/Flex";
import { InfoLabel } from "components/InfoLabel";
import { idPropType } from "constants/app";
import { bool, func, string } from "prop-types";

import classes from "./UserPermissionRow.module.scss";

const UserPermissionRow = ({
  checked,
  disabled,
  heading,
  id,
  onChange,
  text,
  tooltipText,
}) => {
  return (
    <Flex className={clsx(!heading && classes.row)}>
      <InfoLabel
        bold={heading}
        className={classes.label}
        text={text}
        tooltipText={tooltipText}
      />

      <div>
        <Checkbox
          state={checked ? checkboxStates.checked : checkboxStates.empty}
          handleChange={onChange}
          disabled={disabled}
          id={`cb-${id}`}
          value={`${id}-checkbox`}
          ariaLabel={text}
        />
      </div>
    </Flex>
  );
};

UserPermissionRow.propTypes = {
  checked: bool,
  disabled: bool,
  heading: bool,
  id: idPropType,
  onChange: func.isRequired,
  text: string.isRequired,
  tooltipText: string.isRequired,
};

export default UserPermissionRow;
